import { useTranslation } from 'react-i18next';
import Wishlist from '../components/Wishlist/Wishlist';

const SystemWishlist = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full">
      <div className="flex-grow min-h-0">
        <Wishlist isSystem={true} />
      </div>
    </div>
  );
};

export default SystemWishlist;
